module.exports = __webpack_public_path__ + "img/soldOut.c9eab816.svg";